import React from 'react';
import classnames from 'classnames';

import './index.scss';

const StudioManagementMeetingEmps: React.FC<IStudioManagementMeetingEmpsProps> = (props) => {
  const { style, className, emps } = props;

  return (
    <ul style={style} className={classnames('dbg-studio-management-meeting-emp-list', className)}>
      {emps?.length > 0 &&
        emps?.map((emp) => (
          <li key={emp} className="dbg-studio-management-meeting-emp-item">
            {emp}
          </li>
        ))}
    </ul>
  );
};

export default React.memo(StudioManagementMeetingEmps);
